"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @owner fanhu <fanhu@microsoft.com>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseBuildStepDriver = void 0;
class BaseBuildStepDriver {
    execute(args, ctx) {
        const impl = this.getImpl(args, ctx);
        return impl.run();
    }
}
exports.BaseBuildStepDriver = BaseBuildStepDriver;
//# sourceMappingURL=baseBuildStepDriver.js.map